// Configuration for the exam platform
// Auto-detect environment based on domain, with fallback to environment variable

const detectEnvironment = () => {
  // Check environment variable first
  if (process.env.REACT_APP_ENVIRONMENT) {
    return process.env.REACT_APP_ENVIRONMENT;
  }
  
  // Auto-detect based on domain
  const hostname = window.location.hostname;
  if (hostname === 'assessment.cloud.enpro.com') {
    return 'prd';
  } else if (hostname === 'dev-assessment.cloud.enpro.com') {
    return 'dev';
  }
  
  // Default to dev for localhost and other domains
  return 'dev';
};

const ENVIRONMENT = detectEnvironment();



const environments = {
  dev: {
    API_URL: 'https://q8r6aq6m52.execute-api.eu-central-1.amazonaws.com/prod',
    COGNITO_DOMAIN: 'exam-platform-c2bp3ihc.auth.eu-central-1.amazoncognito.com',
    CLIENT_ID: '4ne59houjpo9eb0m745t462i37'
  },
  prd: {
    API_URL: 'https://93lcj6ndm3.execute-api.eu-central-1.amazonaws.com/prod',
    COGNITO_DOMAIN: 'exam-platform-prd-q50qx8bc.auth.eu-central-1.amazoncognito.com',
    CLIENT_ID: '50ldkjdaukac103ds49gnjqa1q'
  }
};

const config = {
  // Environment-specific values
  ...environments[ENVIRONMENT],
  
  // Override with environment variables if provided
  API_URL: process.env.REACT_APP_API_URL || environments[ENVIRONMENT].API_URL,
  COGNITO_DOMAIN: process.env.REACT_APP_COGNITO_DOMAIN || environments[ENVIRONMENT].COGNITO_DOMAIN,
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID || environments[ENVIRONMENT].CLIENT_ID,
  
  // Common configuration
  REDIRECT_URI: window.location.origin + '/callback.html',
  DEFAULT_ASSESSMENT: 'Cloud Operator',
  
  // Current environment
  ENVIRONMENT: ENVIRONMENT
};



export default config;